import executive from './executive';

export default {
	executivePage: executive
}